import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'braceletColor'})
export class DvlBraceletColorPipe implements PipeTransform {
  transform(key: string, bracelets: any[]): string {
    let bracelet: any;
    let rgb: string = '';

    if (bracelets) {
      bracelet = bracelets.find((bracelet) => bracelet.$key === key);
      rgb = bracelet ? bracelet.rgb : '';
    }

    return rgb;
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/pipes/bracelet-color.pipe.ts